export function getdata() {
	var obj = {
		headDataI: [{
				title: "操作",
				prop: "cz",
				width: "150px",
				custom: true,
			},
			{
				title: "卷烟条包装商品条码",
				prop: "xfs_5_x_1",
				width: "150px",
				custom: true,
			},
			{
				title: "卷烟牌号规格",
				prop: "xfs_5_x_2",
				width: "150px",
				custom: true,
			},
			{
				title: "卷烟类别",
				prop: "xfs_5_x_3",
				width: "150px",
				custom: true,
			},
			{
				title: "卷烟类型",
				prop: "xfs_5_x_4",
				width: "150px",
				custom: true,
			},
			{
				title: "销售价格",
				prop: "xfs_5_x_5",
				width: "150px",
				custom: true,
			},
			{
				title: "销售数量",
				prop: "xfs_5_x_6",
				width: "150px",
				custom: true,
			},
			{
				title: "销售额",
				prop: "xfs_5_x_7",
				width: "150px",
				custom: true,
			}, {
				title: "备注",
				prop: "xfs_5_x_8",
				width: "150px",
				custom: true,
			},
		],

		tableDataI: [
			{},
			{
				xfs_5_x_1: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_5_x_2: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_5_x_3: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_5_x_4: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_5_x_5: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_5_x_6: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_5_x_7: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_5_x_8: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
			},

		],
	}
	return obj
}